/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of role activation requirements */
export enum ActivationRequirementType {
  ManagerApproval,
  PeerReview,
  SecurityClearance,
  BackgroundCheck,
  TrainingCompletion,
  CertificationRequired,
  BusinessJustification,
  TechnicalAssessment,
}

export type ActivationRequirementTypeArgs = ActivationRequirementType;

export function getActivationRequirementTypeEncoder(): FixedSizeEncoder<ActivationRequirementTypeArgs> {
  return getEnumEncoder(ActivationRequirementType);
}

export function getActivationRequirementTypeDecoder(): FixedSizeDecoder<ActivationRequirementType> {
  return getEnumDecoder(ActivationRequirementType);
}

export function getActivationRequirementTypeCodec(): FixedSizeCodec<
  ActivationRequirementTypeArgs,
  ActivationRequirementType
> {
  return combineCodec(
    getActivationRequirementTypeEncoder(),
    getActivationRequirementTypeDecoder(),
  );
}
